import { UserType } from '@model/User';
import { useReduxState } from './Redux/useReduxState';

/**
 * Return auth state
 * @returns {boolean}
 */
export const useUser = (): UserType => {
    const { auth, user } = useReduxState({ auth: 'Auth.authenticated', user: 'User._user' });

    return auth ? user : null;
};
